/**
 * Isomorphic port of Ruby CGI.unescape (design D5 of resolve-long-embed-codes): `+`
 * becomes a space, runs of valid `%XX` escapes are hex-decoded and interpreted as UTF-8
 * (invalid byte sequences decode to U+FFFD, matching Node's Buffer#toString("utf8"));
 * malformed percent escapes are left untouched (decodeURIComponent would throw on them).
 * Implemented on TextDecoder so the identical code runs in browsers and in the Lambda
 * runtime — no Node Buffer. ignoreBOM keeps an encoded U+FEFF in the output — the
 * default would strip a leading BOM per decoded run, unlike Buffer#toString (byte
 * parity, Copilot finding on PR #789).
 *
 * The decoder is created lazily on first decode: instantiating it at module scope
 * makes importing this package hard-require TextDecoder even for extractors that
 * never percent-decode — and jest's jsdom test environment does not provide the
 * global (jsdom/jest gap; real browsers and Node both have it).
 */
// Structural type — `TextDecoder` is not usable as a type name under @types/node
// without dom lib (editor-backend compiles this source), only as a value.
let utf8Decoder: {decode(input: Uint8Array): string} | undefined

export function cgiUnescape(value: string): string {
  return value.replace(/\+/g, " ").replace(/(?:%[0-9a-fA-F]{2})+/g, seq => {
    utf8Decoder ??= new TextDecoder("utf-8", {ignoreBOM: true})
    const hex = seq.split("%").slice(1)
    const bytes = new Uint8Array(hex.length)
    for(let i = 0; i < hex.length; i++) {
      bytes[i] = parseInt(hex[i], 16)
    }
    return utf8Decoder.decode(bytes)
  })
}
